import { buildBrowserUsageContext } from '../../shared/aiUsageRegistry.js';

export function buildClientUsageContext(partial = {}) {
  return buildBrowserUsageContext(partial);
}

export function buildUsageHeaders(partial = {}) {
  const usageContext = buildClientUsageContext(partial);
  const headers = {};
  if (usageContext.pageKey) headers['X-App-Page-Key'] = usageContext.pageKey;
  if (usageContext.pagePath) headers['X-App-Page-Path'] = usageContext.pagePath;
  if (usageContext.featureKey) headers['X-Usage-Feature-Key'] = usageContext.featureKey;
  if (usageContext.endpointKey) headers['X-Usage-Endpoint-Key'] = usageContext.endpointKey;
  return headers;
}

export function attachUsageContext(payload = {}, partial = {}) {
  return {
    ...payload,
    usageContext: buildClientUsageContext(partial),
  };
}

